import React from 'react';
import { Star } from 'lucide-react';

// Display stars for a numeric rating
export const StarsDisplay = ({ value = 0, size = 15 }) => (
  <span className="inline-flex items-center gap-0.5">
    {[1, 2, 3, 4, 5].map((n) => (
      <Star key={n} size={size} className={n <= Math.round(value) ? 'fill-amber-400 text-amber-400' : 'text-gray-300'} />
    ))}
  </span>
);

// Interactive star input
export const StarsInput = ({ value, onChange, size = 28 }) => (
  <div className="inline-flex items-center gap-1" data-testid="stars-input">
    {[1, 2, 3, 4, 5].map((n) => (
      <button type="button" key={n} data-testid={`star-${n}`} onClick={() => onChange(n)} className="transition-transform hover:scale-110">
        <Star size={size} className={n <= value ? 'fill-amber-400 text-amber-400' : 'text-gray-300 hover:text-amber-300'} />
      </button>
    ))}
  </div>
);
